import _ from 'lodash';
import { FOX } from 'helpers/ContentHelper';
import { FETCH_NAV_SCHEDULE } from './NavScheduleActions';
import { getNetworkPanel } from './NavScheduleHelper';

const INITIAL_STATE = {
  schedule: null,
};

export default function(state = INITIAL_STATE, action) {
  const data = _.get(action, 'payload.data', null);
  const panels = _.get(data, 'panels', null);

  switch (action.type) {
    case FETCH_NAV_SCHEDULE: {
      if (!data) return state;
      const schedule = getNetworkPanel({ network: FOX, panels });
      return {
        ...state,
        schedule,
      };
    }
    default: {
      return state;
    }
  }
}
